// Per-service SEO landing page metadata.
export const SERVICES = [
  {
    slug: "recupero-auto-incidentate-roma",
    name: "Recupero auto incidentate",
    title: "Recupero Auto Incidentate Roma H24 | Carroattrezzi Roma",
    description:
      "Recupero auto incidentate a Roma e provincia, 24 ore su 24. Mezzi attrezzati per ogni situazione, intervento rapido. Chiama 06 9763 6222.",
    h1: "Recupero Auto Incidentate a Roma H24",
    intro:
      "Servizio di recupero auto incidentate a Roma e provincia, attivo 24 ore su 24, 7 giorni su 7. Operiamo con mezzi attrezzati per ogni tipologia di sinistro, anche in situazioni critiche: ribaltamenti, fuoriuscite di carreggiata, danneggiamenti gravi. Personale qualificato e prezzo trasparente al telefono.",
    keywords:
      "recupero auto incidentate Roma, recupero auto incidente Roma, carro attrezzi incidente Roma",
  },
  {
    slug: "batteria-scarica-roma",
    name: "Batteria scarica",
    title: "Batteria Scarica Roma H24 | Avviamento Auto - 06 9763 6222",
    description:
      "Batteria scarica a Roma? Avviamento di emergenza sul posto 24/7. Intervento rapido in tutta Roma e provincia. Chiama subito 06 9763 6222.",
    h1: "Batteria Scarica a Roma — Intervento H24",
    intro:
      "Avviamento di emergenza per batteria scarica direttamente sul posto, a Roma e provincia. Arriviamo con mezzo attrezzato per dare corrente alla tua auto o moto in pochi minuti. Servizio attivo 24 ore su 24, anche di notte e nei festivi.",
    keywords:
      "batteria scarica Roma, avviamento batteria Roma, batteria auto scarica Roma",
  },
  {
    slug: "traino-moto-roma",
    name: "Traino moto",
    title: "Traino Moto Roma H24 | Soccorso Stradale Moto - Carroattrezzi",
    description:
      "Traino e recupero moto a Roma H24. Soccorso stradale dedicato per scooter e motociclette in qualsiasi zona. Chiama 06 9763 6222.",
    h1: "Traino Moto a Roma — Soccorso Stradale H24",
    intro:
      "Servizio di traino e recupero moto e scooter a Roma e provincia, attivo 24 ore su 24. Disponiamo di mezzi dedicati con rampa morbida e sistemi di ancoraggio sicuri, anche per moto di grossa cilindrata o scooter incidentati.",
    keywords:
      "traino moto Roma, recupero moto Roma, soccorso stradale moto Roma",
  },
  {
    slug: "auto-in-panne-roma",
    name: "Auto in panne",
    title: "Auto in Panne Roma H24 | Soccorso Stradale Rapido 06 9763 6222",
    description:
      "Auto in panne a Roma? Soccorso stradale rapido H24, riavvio sul posto o traino fino all'officina. Intervento immediato. 06 9763 6222.",
    h1: "Auto in Panne a Roma — Soccorso H24",
    intro:
      "Auto in panne a Roma? Interveniamo 24 ore su 24 con mezzi attrezzati: tentiamo l'avviamento sul posto, oppure ti trainiamo fino alla tua officina di fiducia o a casa. Pagamento con contanti o carta direttamente sul posto.",
    keywords:
      "auto in panne Roma, soccorso auto panne Roma, carro attrezzi panne Roma",
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
